import React from 'react';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import * as actions from 'hellospa/page/prep-and-send/data/actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { useIntl, FormattedMessage } from 'react-intl';

import styles from '../index.scss';
import messages from '../intl';
import FileStatus from '../../file-uploader/file-status';


type BulkSendButtonProps = {
  signerFile: types.SignerFile | null,
}

const BulkSendButton = ({
  signerFile,
}: BulkSendButtonProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const isBulkSend = useSelector(selectors.isBulkSend);
  const csvData = useSelector(selectors.getBulkSendExampleData);

  const onDrop = React.useCallback(async (files: File[]) => {
    const file = files[0];
    dispatch(actions.saveSignerCSV(file));
    const error = await dispatch(actions.validateBulkSendSigners(file));
    if (typeof error === 'string') {
      dispatch(actions.setBulkSendData({
        signerFile: {
          name: file.name,
          status: types.FilePollResponseStatus.Converting,
          type: types.UserFileTypes.Signer,
          error,
        },
      }));
    } else {
      dispatch(actions.markSignerCSVComplete(file));
    }
  }, [dispatch]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });

  if (!isBulkSend) {
    return null;
  }

  const toggleButton = !signerFile || signerFile.error;

  return (
    <div className={styles.bulkCsvSection}>
      <div>{intl.formatMessage(messages.signerCSVSubText, {
        // eslint-disable-next-line react/display-name
        b: (body: string) => (<a href={csvData} key='bulk-example-link' download="BulkSendExample.csv">{body}</a>),
        // eslint-disable-next-line react/display-name
        a: (body: string) => (<a
          key='bulk-help-link'
          href="https://faq.hellosign.com/hc/en-us/articles/360026162552-How-to-Send-Requests-in-Bulk"
          target="_blank"
          rel="noopener noreferrer"
        >{body}</a>),
      })}
      </div>
      <div className={styles.bulkCsvFileSection}>
        {toggleButton && (<span {...getRootProps()}>
          <input {...getInputProps()} data-qa-ref="upload-input" />
          <Button
            data-qa-ref="upload-csv-file"
            kind={ButtonType.Outline}
          >

            <FormattedMessage
              id=""
              description="button text for upload CSV"
              defaultMessage="Upload CSV" />
          </Button>
        </span>)}
        {!toggleButton && signerFile && <FileStatus index={0} file={signerFile} />}
      </div>
    </div>
  );
};
export default BulkSendButton;
